import axios from "axios";
import _BaseAPIService from "../../../services/_BaseAPIService";

const apiService = _BaseAPIService.instance;
_BaseAPIService.instance = axios.create({
  baseURL: window.APP_CONFIG.api2.baseapi,
});

const baseURL = window.APP_CONFIG.api1.baseapi;
console.log("🚀 ~ baseURL:", baseURL);

const ConnectIpsServices = {
  getConnectIpsToken: async (orderId, orgcode) => {
    console.log("🚀 ~ orgcode:", orgcode);
    console.log("🚀 ~ orderId:", orderId);
    try {
      const response = await axios.post(
        `${baseURL}/payments/connectipstoken`,
        null,
        {
          params: { OrderRef: orderId },
          headers: {
            "Content-Type": "application/json",
            APIKEY: orgcode,
          },
        },
      );
      console.log("🚀 ~ response:", response);
      return response;
    } catch (error) {
      console.error("Get Connect IPS Token Error:", error);
      throw error?.response?.data || error;
    }
  },

  generateQR: async (data = {}, orgcode) => {
    try {
      const response = await axios.post(
        `${baseURL}/payments/generate-qr`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            APIKEY: orgcode,
          },
        },
      );
      console.log("🚀 ~ generateQR response:", response);
      return response;
    } catch (error) {
      console.error("Generate QR Error:", error);
      throw error?.response?.data || error;
    }
  },

  validateConnectIpsPayment: async (orderRef, orgcode) => {
    try {
      const response = await axios.post(
        `${baseURL}/payments/connectipsvalidatepayment`,
        null,
        {
          params: { orderRef },
          headers: {
            "Content-Type": "application/json",
            APIKEY: orgcode,
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Validate Connect IPS Payment Error:", error);
      throw error?.response?.data || error;
    }
  },
};

export default ConnectIpsServices;
